import React, {
  useEffect, useRef, useState,
} from 'react';

import ApproveGuaranteeModal from './ApproveGuaranteeModal';

import MarkAsPaidComp from '../../AdminRepaymentDetails/RepaymentSchedule/RepaymentDetailsCard/MarkAsPaidComp';
import CardLabelAndTitle from '../../../components/CardLabelAndTitle';
import RolesAndPermissionGuard from '../../../components/RolesAndPermissionGuard';
import StyledButton from '../../../components/StyledButton';
import SummaryDetailsCover from '../../../components/SummaryDetailsCover';
import RecordDropdown from '../../../components/MerchantDropdown';

import MarkAsPaid from '../../../svgs/MarkAsPaid';
import ProcessRefundIcon from '../../../svgs/ProcessRefundIcon';
import FulfilLoanDropdownIcon from '../../../svgs/FulfilLoanDropdownIcon';
import ListIcon from '../../../svgs/ListIcon';

import './GuaranteeSummary.scss';
import UserDetailsCardCa from '../../../components/UserDetailsCardCa';

interface IGuaranteeSummary{
  payload?:any;
  refetch?:any;
}
const GuaranteeSummary = ({ payload, refetch }:IGuaranteeSummary) => {
  const [modalDetail, setModalDetail] = useState({
    title: 'Decline Guarantee',
    subTitle: 'Are you sure you want to decline this guarantee?',
    type: 'decline',
  });
  const isPreApproval = payload?.guaranteeType === 'pre-approval';
  const [showApproveGuaranteeModal, setShowApproveGuaranteeModal] = useState(false);
  const [toggleDropdown, setToggleDropDown] = useState(false);
  const disableFulfilGuaranteeButton = !((payload?.status === 'AWAITING_APPROVAL') || (isPreApproval && payload?.status === 'PAID'));
  const [isMarkAsPaidOnHover, setIsMarkAsPaidOnHover] = useState(false);
  const [markAsPaidModal, setMarkAsPaidModal] = useState(false);
  const isPreApprovalAndAwaitingPayment = payload?.status === 'AWAITING_PAYMENT';
  const toggleRef = useRef<HTMLDivElement>(null);
  const handleClick = (e) => {
    if (toggleRef?.current?.contains(e.target)) {
      return;
    }

    setToggleDropDown(false);
  };

  useEffect(() => {
    window.addEventListener('click', handleClick);
    return () => {
      window.removeEventListener('click', handleClick);
    };
  }, []);

  const dropDownData = [
    {
      title: 'Approve Request', icon: <FulfilLoanDropdownIcon />, color: '#05603A', disabled: disableFulfilGuaranteeButton,
    },
    {
      title: 'Decline Request', icon: <ProcessRefundIcon />, color: '#D92D20', disabled: disableFulfilGuaranteeButton,
    },
  ];

  const handleDropDown = (title) => {
    setToggleDropDown(!toggleDropdown);
    if (title === 'Approve Request') {
      setShowApproveGuaranteeModal(true);
      setModalDetail({
        title: `Approve ${isPreApproval ? 'Pre Approval' : ''} Guarantee`,
        subTitle: `Are you sure you want to approve this ${isPreApproval ? 'pre-approval' : ''} guarantee request?`,
        type: 'approve',
      });
    }
    if (title === 'Decline Request') {
      setShowApproveGuaranteeModal(true);
      setModalDetail({
        title: `Decline ${isPreApproval ? 'Pre Approval' : ''} Guarantee`,
        subTitle: `Are you sure you want to decline this ${isPreApproval ? 'pre-approval' : ''} guarantee request?`,
        type: 'decline',
      });
    }
  };

  const MainGuaranteeFirstCardAttribute = ['amount', 'annualIncome', 'monthlyRent', 'firstAndLastMonthPayment', 'payfiTotalFee'];
  const MainGuaranteeFirstCardLabel = {
    amount: 'Guarantee Amount',
    annualIncome: 'Annual Income',
    monthlyRent: 'Monthly Rent',
    firstAndLastMonthPayment: 'First and Last Month Payment',
    payfiTotalFee: 'Payfi Total Fee',
  };
  const MainGuaranteeSecondCardAttribute = ['landlord', 'landlordPhone', 'leaseStartDate', 'startDate', 'endDate'];
  const MainGuaranteeSecondCardLabel = {
    landlord: 'Landlord',
    landlordPhone: 'Landlord Contact',
    leaseStartDate: 'Lease start date',
    startDate: 'Guarantee Start Date',
    endDate: 'Guarantee Expiry Date',
  };

  const PreApprovalGuaranteeFirstCardAttribute = ['amount', 'monthlyBudget', 'tenor'];
  const PreApprovalGuaranteeFirstCardLabel = {
    amount: 'Guarantee Amount',
    monthlyBudget: 'Monthly Budget',
    tenor: 'Lease Period',
  };
  const PreApprovalGuaranteeSecondCardAttribute = ['apartmentType', 'startDate', 'endDate'];
  const PreApprovalGuaranteeSecondCardLabel = {
    apartmentType: 'Apartment Type',
    startDate: 'Guarantee Start Date',
    endDate: 'Guarantee Expiry Date',
  };

  return (
    <div className="guarantee-summary-cover">
      <SummaryDetailsCover paddingBottom="0px">
        <UserDetailsCardCa payload={payload} paddingBottom="15px" />
        <div className="guarantee-summary-title-and-button-div">
          <div className="guarantee-summary-title">
            Guarantee Summary
          </div>
          <div className="guarantee-summary-button-and-process-refund-button-div">

            <RolesAndPermissionGuard permissionName="can-view-guarantee-details">
              {isPreApprovalAndAwaitingPayment ? (
                <RolesAndPermissionGuard permissionName="can-process-manual-pre-approval-guarantee-update">
                  <StyledButton onClick={() => setMarkAsPaidModal(true)} onMouseEnter={() => setIsMarkAsPaidOnHover(true)} onMouseLeave={() => setIsMarkAsPaidOnHover(false)} gap="12px" icon={<MarkAsPaid style={isMarkAsPaidOnHover ? { fill: '#00C48C', path: '#00C48C' } : ''} />} name="Mark as Paid" color={isMarkAsPaidOnHover ? '#523B9F' : '#667085'} border="none" fontSize="14px" height="40px" backgroundColor={isMarkAsPaidOnHover ? 'rgba(220, 216, 236, 0.7)' : '#fff'} />
                </RolesAndPermissionGuard>
              ) : (
                <div className="guarantee-more-button" ref={toggleRef} onClick={() => setToggleDropDown((prev) => (!prev))}>
                  <StyledButton name="More" color="#667085" border="none" fontSize="14px" height="40px" backgroundColor="#fff" />
                  <ListIcon color="#667085" />
                  {
                    toggleDropdown && (
                    <div className="admin-user-dropdown-cover">
                      <RecordDropdown data={dropDownData} handleDropdown={handleDropDown} />
                    </div>
                    )
                  }
                </div>
              )}

            </RolesAndPermissionGuard>

          </div>
        </div>
        <div className="guarantee-summary-amount-and-status">
          <div className="guarantee-summary-amount">
            <div className="guarantee-summary-amount-label">Guarantee Amount</div>
            <div className="guarantee-summary-amount-div">
              {
                payload?.trxAmount
              }

            </div>
          </div>
          <div className={`${payload?.status} status`}>{payload?.status && payload?.status?.split('_').join(' ') }</div>
        </div>
        <div>
          <CardLabelAndTitle
            content={payload}
            attribute={payload?.guaranteeType === 'pre-approval' ? PreApprovalGuaranteeFirstCardAttribute : MainGuaranteeFirstCardAttribute}
            label={
              payload?.guaranteeType === 'pre-approval' ? PreApprovalGuaranteeFirstCardLabel : MainGuaranteeFirstCardLabel
            }
          />
          <CardLabelAndTitle
            content={payload}
            attribute={payload?.guaranteeType === 'pre-approval' ? PreApprovalGuaranteeSecondCardAttribute : MainGuaranteeSecondCardAttribute}
            label={
              payload?.guaranteeType === 'pre-approval' ? PreApprovalGuaranteeSecondCardLabel : MainGuaranteeSecondCardLabel
            }
          />
        </div>
      </SummaryDetailsCover>

      {
        showApproveGuaranteeModal && (
        <ApproveGuaranteeModal
          refetch={refetch}
          guaranteeId={payload?.id}
          guaranteeType={payload?.guaranteeType}
          isShow={showApproveGuaranteeModal}
          {...modalDetail}
          closeModal={() => {
            setShowApproveGuaranteeModal(false);
          }}
          setModalDetail={setModalDetail}
        />
        )
      }

      {
        markAsPaidModal && (
        <MarkAsPaidComp
          closeModal={() => setMarkAsPaidModal(false)}
          docName={`${payload?.firstName}'s Guarantee Payment`}
          preApprovalGuaranteeId={payload?.id}
          refetch={refetch}
          permissionName="can-process-manual-pre-approval-guarantee-update"
        />
        )
      }

    </div>
  );
};
export default GuaranteeSummary;
